import {useMutation, useQueryClient} from '@tanstack/react-query';
import {PostBeneficiaryParams} from 'domain/usecases';
import {removeAuthTokens, setAuthTokens, setLoginToken} from 'infra/http/utils';
import {clearLocalStorageFeatureFlags} from 'infra/http/utils/clear-local-storage-feature-flags';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {SignInEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';
import {postBeneficiary} from '../../services/postBeneficiary';
import {clearCongenereEligibilityStorage} from 'infra/http/utils/clear-congenere-eligibility-storage';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';

export const usePostBeneficiaryMutation = () => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const resetFacialBiometrics = useFacialBiometricsStore(state => state.resetFacialBiometrics);

	return useMutation({
		mutationKey: [MUTATION_KEYS.BENEFICIARY],
		mutationFn: (params: PostBeneficiaryParams) => postBeneficiary(params),
		onSuccess: data => {
			setLoginToken(data.login_token);
			setAuthTokens(data.access_token, data.refresh_token);
		},
		retry: 2,
		onError: () => {
			removeAuthTokens();
			clearLocalStorageFeatureFlags();
			clearCongenereEligibilityStorage();
			resetFacialBiometrics();
			navigate(SignInEnum.SIGN_IN, {state: {goToSignInState: true}});
			queryClient.clear();
		},
	});
};
